import { z } from 'zod';
import * as uuid from 'uuid';
import * as HLC from '../infrastructure/clock/hybrid-logical-clock';
const UUID_LIKE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuidLike = (id) => UUID_LIKE.test(id);
const tp3IdSchema = z.string().refine(isUuidLike, {
    message: 'Must be a valid UUID',
});
const JAKARTO_SECRET_ARN = /^arn:aws:secretsmanager:[a-z0-9-]+:\d{12}:secret:[\w/+=.@\\-]+$/;
export const isJakartoSecretArn = (value) => JAKARTO_SECRET_ARN.test(value);
const jakartoSecretArnSchema = z.string().refine(isJakartoSecretArn, {
    message: 'Must be a valid AWS Secrets Manager ARN',
});
const hlcSortKeySchema = z.string().refine((value) => {
    try {
        HLC.sortKeyToHLC(value);
        return true;
    }
    catch {
        return false;
    }
}, {
    message: 'Must be a valid HLC sort key format (15-digit-timestamp-5-base36-counter-nodeId)',
});
export const newTp3Id = () => tp3IdSchema.parse(uuid.v4());
export const deterministicTp3Id = (name, namespace = uuid.v3.URL) => tp3IdSchema.parse(uuid.v3(name, namespace));
export const parseJakartoSecretArn = (value) => jakartoSecretArnSchema.parse(value);
export const newHlcSortKey = () => {
    const sortKey = HLC.hlcToSortKey(HLC.HybridLogicalClock.getInstance().generateTimestampNow());
    return hlcSortKeySchema.parse(sortKey);
};
//# sourceMappingURL=types.js.map